import { principles } from "@/mocks/site";

const Principles = () => (
  <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-foreground-950">
    <div className="max-w-7xl mx-auto">
      <div className="max-w-2xl mb-8 md:mb-12">
        <p className="text-sm font-medium text-primary-300 mb-2">整理原则</p>
        <h2 className="font-heading font-black text-2xl md:text-4xl text-background-50">
          吃瓜可以，但要有底线
        </h2>
        <p className="mt-4 text-sm md:text-base text-background-300 leading-relaxed">
          档案局不做审判席，只做信息整理台。以下三条是我们整理每一起事件时都会遵守的原则。
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {principles.map((item) => (
          <article
            key={item.title}
            className="p-5 md:p-7 rounded-lg bg-background-50/[0.06] border border-background-50/15"
          >
            <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-2xl mb-4">
              <i className={item.icon} />
            </span>
            <h3 className="font-heading font-bold text-lg text-background-50">{item.title}</h3>
            <p className="mt-2 text-sm text-background-300 leading-relaxed">{item.desc}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Principles;